import { Component, OnInit, output, input } from '@angular/core';
import { SubtaskSelectButton } from '../../../core/models/subtask-select-button.model';
import { FormatStringPipe } from '../../../core/pipes/format-string.pipe';

import { THEMES } from '../../../core/models/theme.model';

@Component({
  selector: 'wf-subtask-select-button',
  imports: [
    FormatStringPipe
],
  templateUrl: './subtask-select-button.component.html',
  styleUrl: './subtask-select-button.component.css'
})
export class SubtaskSelectButtonComponent implements OnInit {
  readonly taskSelect = input<SubtaskSelectButton | null>(null);

  readonly onTaskSelectClick = output<number>();

  readonly onTaskMouseOver = output<{
    idx: number;
    highlight: boolean;
}>();

  readonly onTaskMouseLeave = output<{
    idx: number;
    highlight: boolean;
}>();

  scoreBoxes: { id: number, score: number, background: string, icon: string, progressed: boolean, completed: boolean, wordListType: number }[] = [] ;

  ngOnInit(): void {
    const completions = this.taskSelect()!.completions ;
    const suffixes = ['a', 'b', 'c', 'd'] ;
    const basePath = `/assets/images/taskSelect/${this.taskSelect()!.theme === THEMES.elementary ? '' : 'theme2/'}scoreboxes/` ;
    let completionIdxs: number[] = [] ;

    // For other tasks, we show the completions
    for (let idx = 0; idx < completions.length; idx++) {
      const { score, completed, progressed, wordListType } = completions[idx];

      const taskSelect = this.taskSelect();
      const taskSelectValue = this.taskSelect();
      this.scoreBoxes.push({
        id: idx,
        score: (taskSelect!.type === 'passage' && taskSelect!.completed) ? 100 : score,
        icon: '',
        background: basePath,
        progressed: (taskSelectValue!.type === 'passage' && taskSelectValue!.completed) ? true : progressed,
        completed: this.taskSelect()!.completed,
        wordListType
      });

      if (completed) completionIdxs.push(idx) ;
    }

    if (this.scoreBoxes.length && !this.taskSelect()!.completed)
    {
      this.scoreBoxes.push({
        id: this.scoreBoxes.length,
        score: 0,
        icon: '',
        background: basePath,
        progressed: false,
        completed: false,
        wordListType: 0,
      }) ;
    }

    // This should not be necessary, but make sure we only have 2 max scoreboxes
    let completedIdx = completionIdxs.length > 1 ? completionIdxs[completionIdxs.length - 2] + 1 : 0 ;
    this.scoreBoxes = this.scoreBoxes.slice(completedIdx, completedIdx + 4) ;

    // Now that we have our final set, determine our backgrounds
    for (let idx = 0 ; idx < this.scoreBoxes.length ; idx++)
    {
      const taskCompletedBg = this.scoreBoxes[idx].completed ? 'gold' : 'default' ;
      const progressedBg = this.scoreBoxes[idx].progressed ? '_star' : '';
      const boxesStr = this.scoreBoxes.length > 1 ? `${this.scoreBoxes.length}${suffixes[idx] ?? 'a'}` : `${this.scoreBoxes.length}`;
      this.scoreBoxes[idx].background += `subtaskScoreBox-${boxesStr}-${taskCompletedBg}${progressedBg}.svg` ;
    }
  }

  onTaskClick() {
    this.onTaskSelectClick.emit(this.taskSelect()!.index);
  }

  onMouseOver() {
    this.onTaskMouseOver.emit({ idx: this.taskSelect()!.index, highlight: true });
  }

  onMouseLeave() {
    this.onTaskMouseLeave.emit({ idx: this.taskSelect()!.index, highlight: false });
  }
}
